import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';

import ForumItemToolbar from './ForumItemToolbar';
import ForumItemScore from './ForumItemScore';
import ForumItemInfo from './ForumItemInfo';

const useStyles = makeStyles((theme) => ({
  scoreLabel: {
    marginTop: -theme.spacing(1.5),
    marginBottom: -theme.spacing(1.5),
  },
  toolbar: {
    marginTop: theme.spacing(2),
  },
}));

const ThreadDetails = (props) => {
  const classes = useStyles();
  const {
    thread,
    loading,
    onEdit,
    onDelete,
    onUpvote,
    onDownvote,
    onReport,
  } = props;

  return (
    <Box width="100%" display="flex">
      <Box mr={2}>
        <ForumItemScore
          item={thread}
          score={thread?.score}
          canUpvote={thread?.canUpvote}
          onUpvote={onUpvote}
          canDownvote={thread?.canDownvote}
          onDownvote={onDownvote}
        />
      </Box>
      <Box flexGrow={1}>
        <Box mb={2}>
          <Typography
            variant="h6"
            loading={loading && !thread?._id}
            skeletonWidth="50%"
            skeletonHeight={32}
          >
            {thread?.title}
          </Typography>
          <ForumItemInfo
            createdAt={thread?.createdAt}
            user={thread?.user}
            loading={loading && !thread?._id}
            edited={thread?.edited}
          />
        </Box>
        <div
          className="ck-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: thread?.content }}
        />
        <ForumItemToolbar
          item={thread}
          loading={loading && !thread?._id}
          canDelete={thread?.canDelete}
          onDeleteItem={onDelete}
          canEdit={thread?.canEdit}
          onEditItem={onEdit}
          className={classes.toolbar}
          onReportItem={onReport}
          canReport={thread?.canReport}
          contentType="post"
        />
      </Box>
    </Box>
  );
};

ThreadDetails.propTypes = {
  thread: PropTypes.object,
  loading: PropTypes.bool,

  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onUpvote: PropTypes.func,
  onDownvote: PropTypes.func,
  onReport: PropTypes.func,
};

ThreadDetails.defaultProps = {
  thread: {},
  loading: false,

  onEdit() {},
  onDelete() {},
  onUpvote() {},
  onDownvote() {},
  onReport() {},
};

export default ThreadDetails;
